// @core/api/endpoints/webhook/publish_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PublishEventRequest,
  PublishEventResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Publish event
 * Performs publish operation on event.
 */
export async function PublishEvent(
  data: PublishEventRequest,
  options?: RequestOptions
): Promise<PublishEventResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/publish_event`;
  const requestOptions = options;
  return client.post<PublishEventResponse>(requestPath, data, requestOptions);
}
